var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLoaded)?_c('div',{staticClass:"adSets table-body"},_vm._l((_vm.adSets),function(adSet){return _c('facebook-ads-table-row',{key:adSet.id,attrs:{"type":"adSet","status":_vm.status,"ad-set":adSet}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }